import slotState from '@models/slot'
import { isPositiveInteger } from '@functions/validations'
import { traverseObject } from '@functions/traverseObject'

const state = {
  address: {
    address: '',
    postcode: '',
    state: '',
    suburb: '',
  },
  bookable_services: [],
  contact_number: '',
  flags: [],
  minimum_slots: '',
  primary_category: '',
  secondary_categories: [],
  services: [],
  services_selected: [],
  slots: slotState,
  virtual_contact_number: '',
  zones: [],
}

const addressFieldKeys = [
  'provider.address.address',
  'provider.address.suburb',
  'provider.address.state',
  'provider.address.postcode',
]

const isFilled = value => value !== '' && value !== null && value !== undefined

// Address is all-or-none: empty is fine, but if any field is filled then all must be filled.
const requireCompleteAddress = (val, entityState) => {
  const anyFilled = addressFieldKeys.some(key => isFilled(traverseObject(key, entityState)))
  return anyFilled ? isFilled(val) : true
}

export const customProviderRequiredFields = [
  { key: 'provider.services' },
  { key: 'provider.minimum_slots', validation: isPositiveInteger, invalidMessage: 'Positive integer only', allowNullOrEmpty: false },
  ...addressFieldKeys.map(key => ({ key, validation: requireCompleteAddress, invalidMessage: 'Required' })),
]

export default state
